import React, { useMemo, useState } from 'react';
import CommonTab from '../../components/tabComponent/CommonTab';
import CustomerPortalDocumentTypeAccess from './documentTypeAccess';
import CustomerPortalDocumentSize from './documentSize';
var CustomerPortalDocumentManagement = function () {
    var _a = useState(0), activeTab = _a[0], setActiveTab = _a[1];
    var tabs = useMemo(function () { return [
        {
            label: 'Document Type Access',
            content: React.createElement(CustomerPortalDocumentTypeAccess, null),
        },
        {
            label: 'Document Size',
            content: React.createElement(CustomerPortalDocumentSize, null),
        },
    ]; }, []);
    return (React.createElement(CommonTab, { tabs: tabs, activeIndex: activeTab, onTabChange: setActiveTab }));
};
export default CustomerPortalDocumentManagement;
